/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import * as Yup from 'yup'
import { useFormik } from 'formik'
import { IUpdatePassword, updatePassword } from '../SettingsModel'
import { login, resetPasswordUser } from '../../../../auth/core/_requests'
import { useAuth, UsuarioDtoLogin } from '../../../../auth'
import { LoadingIndicator } from '../../../../../components'
import { showError } from '../../../../../../_metronic/helpers'
import { senhaForteSchema } from '../../../../auth/components/validation/senhaForteSchema'

const passwordFormValidationSchema = Yup.object().shape({
  currentPassword: Yup.string()
    .min(3, 'Mínimo de 3 caracteres')
    .max(50, 'Máximo de 50 caracteres')
    .required('Senha é obrigatória'),
  newPassword: senhaForteSchema().required('Senha é obrigatória'),
  passwordConfirmation: Yup.string()
    .required('Senha é obrigatória')
    .oneOf([Yup.ref('newPassword'), null], 'As senhas não conferem'),
})

export const SignInMethod: React.FC = () => {
  const [passwordUpdateData, setPasswordUpdateData] = useState<IUpdatePassword>(updatePassword)

  const [showPasswordForm, setPasswordForm] = useState<boolean>(false)

  const user = useAuth()
  const formik2 = useFormik<IUpdatePassword>({
    initialValues: {
      ...passwordUpdateData,
    },

    validationSchema: passwordFormValidationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setTimeout(() => {
        setSubmitting(true)
        const credentials: UsuarioDtoLogin = {
          email: String(user.currentUser?.email),
          senha: values.currentPassword,
        }
        login(credentials)
          .then(() => {
            resetPasswordUser(
              String(user.currentUser?.id),
              values.currentPassword,
              values.newPassword,
              values.passwordConfirmation
            )
              .then(() => {
                setSubmitting(false)
                setPasswordUpdateData(values)
                setPasswordForm(false)
                user.logout()
              })
              .catch((error) => {
                setSubmitting(false)
                showError(error)
                setStatus('Não foi possível alterar a senha')
              })
          })
          .catch((error) => {
            showError(error)
            setSubmitting(false)
            setStatus('Login incorreto')
          })
      }, 1000)
    },
  })

  return (
    <div className='card mb-5 mb-xl-10'>
      <div
        className='card-header border-0 cursor-pointer'
        role='button'
        data-bs-toggle='collapse'
        data-bs-target='#kt_account_signin_method'
      >
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Autenticação</h3>
        </div>
      </div>

      <div id='kt_account_signin_method' className='collapse show'>
        <div className='card-body border-top p-9'>
          <div className='d-flex flex-wrap align-items-center mb-10'>
            <div id='kt_signin_password' className={' ' + (showPasswordForm && 'd-none')}>
              <div className='fs-6 fw-bolder mb-1'>Senha</div>
              <div className='fw-bold text-gray-600'>************</div>
            </div>

            <div
              id='kt_signin_password_edit'
              className={'flex-row-fluid ' + (!showPasswordForm && 'd-none')}
            >
              <form
                onSubmit={formik2.handleSubmit}
                id='kt_signin_change_password'
                className='form'
                noValidate
              >
                <div className='row mb-1'>
                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='currentpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Senha Atual
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='currentpassword'
                        {...formik2.getFieldProps('currentPassword')}
                      />
                      {formik2.touched.currentPassword && formik2.errors.currentPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.currentPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='newpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Nova Senha
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='newpassword'
                        {...formik2.getFieldProps('newPassword')}
                      />
                      {formik2.touched.newPassword && formik2.errors.newPassword && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.newPassword}</div>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='col-lg-4'>
                    <div className='fv-row mb-0'>
                      <label htmlFor='confirmpassword' className='form-label fs-6 fw-bolder mb-3'>
                        Confirme a nova senha
                      </label>
                      <input
                        type='password'
                        className='form-control form-control-lg form-control-solid '
                        id='confirmpassword'
                        {...formik2.getFieldProps('passwordConfirmation')}
                      />
                      {formik2.touched.passwordConfirmation && formik2.errors.passwordConfirmation && (
                        <div className='fv-plugins-message-container'>
                          <div className='fv-help-block'>{formik2.errors.passwordConfirmation}</div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div className='form-text mb-5'>
                  Utilize 8 ou mais caracteres com números, letras e caracteres especiais.
                </div>

                <div className='d-flex'>
                  <button
                    id='kt_password_submit'
                    type='submit'
                    className='btn btn-primary me-2 px-6'
                  >
                    {!formik2.isSubmitting ? 'Atualizar senha' : <LoadingIndicator />}
                  </button>
                  <button
                    onClick={() => setPasswordForm(false)}
                    id='kt_password_cancel'
                    type='button'
                    className='btn btn-secondary'
                  >
                    Cancelar
                  </button>
                </div>
              </form>
            </div>

            <div
              id='kt_signin_password_button'
              className={'ms-auto ' + (showPasswordForm && 'd-none')}
            >
              <button onClick={() => setPasswordForm(true)} className='btn btn-secondary'>
                Alterar Senha
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
